import createLineItem from '@models/lineItem';
import { Order, OrderData } from '@repo/ui/src/types/order';

export const formatOrder = (order: OrderData): Order => ({
  ...order,
  details: {
    ...order.details,
    productItems: order.details.productItems?.map((lineItem, i) => createLineItem(lineItem, i)),
  },
});
